<template>
  <div>
    <div class="event_trainer event_trainer_replacement" ref="eventTrainerReplacement" v-if="trainerReplacement">
      <div class="event_trainer_avatar">
        <img :src="trainerReplacement.avatar || require('@/assets/img/default_avatar_female.png')" alt="Тренер по замене" />
      </div>
      <div class="event_trainer_right">
        <div class="event_trainer_right_top">
          <div class="event_trainer_surname">
            {{trainerReplacement.surname}} {{trainerReplacement.name}}
          </div>
        </div>
      </div>
    </div>
    <div class="event_trainer" ref="eventTrainer">
      <div class="event_trainer_avatar" v-bind:class="{ strike: trainerReplacement }">
        <img :src="trainer.avatar || require('@/assets/img/default_avatar_female.png')" alt="Тренер" />
      </div>
      <div class="event_trainer_right">
        <div class="event_trainer_right_top">
          <div class="event_trainer_surname" v-bind:class="{ strike: trainerReplacement }">
            {{trainer.surname}} {{trainer.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventModalTrainer",
  props: {
    trainer: {
      type: Object,
      default: function () {
        return {}
      }
    },
    trainerReplacement: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
}
</script>
